var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"btn-center",attrs:{"color":"primary","dark":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.downloadResults}},[_vm._v(" Download results ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }